module.exports = __webpack_public_path__ + "5cbe8a87a0c9d52c0a74dc8b321bb995.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/payment/social-4.jpg
// module id = ./assets/images/payment/social-4.jpg
// module chunks = 0